import { load, save } from '../lib/storage.js';

/** Anzeige des Zustands eines Moduls: [Text, Pill-Art]. */
export const ZUSTAND = {
  an: ['Aktiv', 'ok'],
  verfuegbar: ['Verfügbar', 'info'],
  beantragt: ['Beantragt', 'warn'],
  'nicht-verfuegbar': ['Voraussetzung fehlt', 'grey'],
  bald: ['Bald', 'grey'],
};

/** Auf diesem Gerät beantragte Module – sobald eines aktiv ist, meldet die App es einmal (ModulHinweis). */
const KEY = 'module.beantragt';
export const beantragteModule = () => load(KEY, []);
export const merkeBeantragt = (id) => save(KEY, [...new Set([...beantragteModule(), id])]);
export function vergissBeantragt(ids) {
  const rest = beantragteModule().filter((x) => !ids.includes(x));
  save(KEY, rest.length ? rest : null);
}
